import type { ReactionType } from './reactions';

export type LimitedReaction = Extract<ReactionType, 'CELEBRATE' | 'LAUGH' | 'LIKE' | 'LOVE' | 'SAD' | 'THANK'>;

// istanbul ignore next
export const limitedReactions: LimitedReaction[] = ['CELEBRATE', 'LAUGH', 'LIKE', 'LOVE', 'SAD', 'THANK'];
